
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","viewBox":"0 0 17 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.292 11.48L2.558 19.95C1.478 20.69 0 19.892 0 18.586V1.646C0 .34 1.479-.455 2.558.285l12.731 8.468c.969.624.969 2.103.003 2.727z","fill":"currentColor"}})])
          )
        }
      }
    